module.exports = __webpack_public_path__ + "img/arachides.eb22111d.svg";